export const GreenCheck = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.9993 4.66675C15.1193 4.66675 4.66602 15.1201 4.66602 28.0001C4.66602 40.8801 15.1193 51.3334 27.9993 51.3334C40.8793 51.3334 51.3327 40.8801 51.3327 28.0001C51.3327 15.1201 40.8793 4.66675 27.9993 4.66675ZM23.3327 39.6667L11.666 28.0001L14.956 24.7101L23.3327 33.0634L41.0427 15.3534L44.3327 18.6667L23.3327 39.6667Z"
      fill="#1FDB38"
    />
  </svg>
);
